import React, { useMemo } from 'react';

import {
  TextField,
  ArrayField,
  Datagrid,
  useRedirect,
  useRecordContext,
  usePermissions,
} from 'react-admin';

import {
  Card,
  CardHeader,
  Divider,
  Button,
} from '@mui/material';

import { boldDataGridStyle } from '../../../../../constants/style/datagridStyles';

import useRelatedEntities from '../../../../../hooks/useRelatedEntities';
import NoResults from '../../../../layout/NoResults';
import entityTypes from '../../../../../constants/entityTypes';
import ReferenceEntityField from '../../../../../customFields/ReferenceEntityField';
import EntityDisplayNameField from '../../../../../customFields/EntityDisplayNameField';
import actions, { Actions } from '../../../../../constants/actions';
import hasAccess from '../../../../../utilities/hasAccess';
import PermissionMissing from '../../../../utils/PermissionMissing';

const RelatedIndividualsListPreview = () => {
  const { currentEntities } = useRelatedEntities();

  const individuals = useMemo(
    () => currentEntities
      .filter((entity) => entity.entityType === entityTypes.INDIVIDUAL),
    [currentEntities],
  );

  const redirect = useRedirect();
  const record = useRecordContext();

  const handleKycTabChange = () => {
    redirect('kyc-data/related-individuals', 'businesses', record?.id);
  };
  const { permissions } = usePermissions<Actions[]>();
  if (!hasAccess(permissions, actions.INDIVIDUAL_LIST)) return <PermissionMissing />;

  if (individuals?.length > 0) {
    return (
      <Card variant="outlined">
        <CardHeader
          sx={{
            color: 'black',
            fontWeight: 'bold',
          }}
          slotProps={{ title: { variant: 'inherit' } }}
          title={`Related individuals: ${individuals.length}`}
          action={<Button onClick={handleKycTabChange} color="secondary">See more</Button>}
        />
        <Divider />
        <ArrayField record={{ individuals }} source="individuals">
          <Datagrid sx={boldDataGridStyle} bulkActionButtons={false}>
            <ReferenceEntityField source="" label="Individual" idKey="entityId" typeKey="entityType">
              <EntityDisplayNameField />
            </ReferenceEntityField>
            <TextField source="relation" />
          </Datagrid>
        </ArrayField>
      </Card>
    );
  }
  return <NoResults />;
};

export default RelatedIndividualsListPreview;
